module.exports = __webpack_public_path__ + "img/layoutRightWhite.13899c56.svg";